import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DatiqInputErrorTypes } from '@dat/datiq-components-pkg/utils';
import { diffBetweenDates } from './datiq-datepicker-validator-utils';

export const minDays: (days: number) => ValidatorFn = (
    days: number
): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const diff: number =
            diffBetweenDates(control.value?.start, control.value?.end, 'days') +
            1;
        const invalid: boolean = diff < days;

        return invalid
            ? {
                  [DatiqInputErrorTypes.DateMinDays]: {
                      actual: diff,
                      min: days,
                  },
              }
            : null;
    };
};
